import { registerComponent } from '../app'
import { VARIANT_CHANGE } from '../events'

const VariantBackground = (scope, el) => {
	scope.on(VARIANT_CHANGE, variant => {
		if (!variant.background_color || !variant.background_color.length) return
		el.style.backgroundColor = variant.background_color
	})
}

registerComponent('variant-background', VariantBackground)
